export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  budget: state => state.budget,
  budgets: state => state.budgets,
  downloadLink: state => state.downloadLink,
  exportLoading: state => state.exportLoading,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Budget/getters.js